import { useTranslation } from 'react-i18next';
import BillSkeleton from '@/components/Skeletons/BillSkeleton';
import { useCheckoutContext } from '@/context/CheckoutContext/CheckoutContext';
import { useBill } from '@/hooks/useBill';
import { SplitBillInfo } from '../SplitBillInfo/SplitBillInfo';
import styles from './Bill.module.scss';
import { BillPositions } from './components/BillPositions';
import { BillSplitByItemsPositions } from './components/BillSplitByItemsPositions';
import NoBill from './components/NoBill';

export const Bill = () => {
  const { t } = useTranslation();
  const { state } = useCheckoutContext();
  const billPaused = state.isProcessing;
  const isItemsSplit = state.splitType === 'SPLIT_BY_ITEMS';

  const { data, isError, isPending } = useBill({
    paused: billPaused,
  });

  if (isPending) {
    return <BillSkeleton />;
  }

  if (isError) {
    return <NoBill />;
  }

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <h2 data-testid="dine-in-order-header">{t('checkout.bill.yourOrder')}</h2>
        <p className={styles.orderNumber} data-testid="dine-in-order-number">
          #{data.orderNumber}
        </p>
      </div>
      {isItemsSplit ? (
        <BillSplitByItemsPositions
          positions={data.positions}
          grossDiscount={data.grossDiscount || 0}
          orderNumber={data.orderNumber}
        />
      ) : (
        <BillPositions positions={data.positions} />
      )}
      <SplitBillInfo />
    </div>
  );
};
